/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldDisplayWrapper } from "cms/fields/layout/field-display-wrapper";
import { SimplicityImage } from "cms/images/simplicity-image";
import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";
import { isArrayNotEmpty } from "utils/empty-exists";

const ImageFieldDisplay = () => {
    
    const { field } = useCurrentDynamicField();
    const { values } = field || {};
    
    return (
        <FieldDisplayWrapper>
            {isArrayNotEmpty(values) && (
                <div className='image-field-list'>
                    {values.map((item, index) => {
                        const { value, settings } = item || {};
                        return (
                            <SimplicityImage
                                key={index}
                                image={value}
                                settings={settings}
                            />
                        );
                    })}
                </div>
            )}
        </FieldDisplayWrapper>
    );
};
ImageFieldDisplay.displayName = "ImageFieldDisplay";
export { ImageFieldDisplay };

//    Structure of an image
//
// const image = {
//     id: 228,
//     guid: '1afb8ea8-b798-43fe-8e51-6a7cc8d06b78',
//     organization: '229dc6b8-b28d-459f-881e-f699cf7f3a1a',
//     title: 'joel-vodell-TApAkERW5pQ-unsplash.jpg',
//     description: null,
//     storage_account: 'simplicityappimages',
//     storage_container: 'images',
//     storage_filepath: 'joel-vodell-TApAkERW5pQ-unsplash.jpg',
//     storage_url: 'https://simplicityappimages.blob.core.windows.net/images/joel-vodell-TApAkERW5pQ-unsplash.jpg',
//     url: 'https://images-dnv.simplicitycms.ca/images/joel-vodell-TApAkERW5pQ-unsplash.jpg',
//     file_name: 'joel-vodell-TApAkERW5pQ-unsplash.jpg',
//     file_ext: 'jpg',
//     file_type: 'image/jpeg',
//     file_size: 3121975,
//     width: 680,
//     height: 400,
//     updated_at: '2022-10-13 20:12:59',
//     updated_by: '852725ec-ac64-452b-be05-e3b8f123a5bf',
//     created_at: '2022-10-13 20:12:59',
//     created_by: '852725ec-ac64-452b-be05-e3b8f123a5bf',
// }
